
// heading text animation
document.addEventListener("DOMContentLoaded", function () {
  // const split_text = document.querySelectorAll("h1, h2, h3, h4, h5, h6");
const split_text = document.querySelectorAll(".split_text, .splitText");

split_text.forEach((el) => {
  const split = new SplitText(el, {
    type: "lines,words,chars",
    linesClass: "line",
    wordsClass: "word",
    charsClass: "char"
  });

  gsap.set(el, { visibility: "visible" });

  const charStagger = 0.008;   // left→right inside each line
  const lineStagger = 0.08;   // delay between lines (top→bottom)

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: el,
      start: "top 100%",
      toggleActions: "play none none none"
    }
  });

  // animate each line’s characters left→right; lines stagger sequentially
  split.lines.forEach((line, i) => {
    const chars = line.querySelectorAll(".char");
    tl.from(chars, {
      yPercent: 120,
      opacity: 0,
      rotationX: -90,
      transformOrigin: "0% 100%",
      ease: "power2.out",
      duration: 0.8,
      stagger: { each: charStagger, from: "start" }
    }, i * lineStagger);
  });
});



// body text animation fade-in with subtle swipe-up
gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".fade-text, .fadeText").forEach((el) => {
  // Set initial state
  gsap.set(el, { opacity: 0, y: 10 });

  // Check if already in viewport AND above 80% threshold
  const rect = el.getBoundingClientRect();
  const top80 = window.innerHeight * 0.8;

  if (rect.top < window.innerHeight && rect.top > top80) {
    // In viewport but before ScrollTrigger threshold → animate manually
    gsap.to(el, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power1.out",
      delay: 1, // small delay added here
    });
  } else {
    // Otherwise, let ScrollTrigger handle it
    gsap.to(el, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power1.out",
      delay: 0.25, // small delay added here
      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        toggleActions: "play none none none",
        once: true,
        // markers: true, // uncomment for debugging
      },
    });
  }
});

ScrollTrigger.refresh();




  // collapsible content-style one cursor animation
const cursor = document.getElementById("invertedcursor");
const toggles = document.querySelectorAll("#content-wrapper-section .collapsible-content__toggle");

toggles.forEach((toggle) => {
  toggle.addEventListener("mouseenter", () => {
    cursor.style.opacity = "1";
  });

  toggle.addEventListener("mouseleave", () => {
    cursor.style.opacity = "0";
  });

  toggle.addEventListener("mousemove", function (e) {
    let x = e.clientX + window.scrollX;
    let y = e.clientY + window.scrollY;

    gsap.to(cursor, {
      x: x,
      y: y,
      duration: 0.2,
      ease: "power2.out"
    });
  });
});



  // bg-gradient animation
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".bg-gradient .bg-gradient-item-wrapper",
      start: "top center",
      end: "bottom center",
      scrub: false,
      markers: false,
    },
  });
  const test_split = document.querySelectorAll(".gradient-test-split");
  test_split.forEach((el) => {
    const split = new SplitText(el, {
      type: "lines words",
      linesClass: "line",
      wordsClass: "words",
    });
  });

  tl.fromTo(
    ".bg-gradient-item",
    {
      xPercent: -100,
      //   opacity: 0,
    },
    {
      xPercent: 0,
      //   opacity: 1,
      ease: "power1.out",
      duration: 1,
      stagger: 0.1,
    }
  )
    .fromTo(
      ".bg-gradient .multicolumn-list",
      {
        opacity: 0,
        y: 30,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power4.out",
      }
    )
    .fromTo(
      document.querySelectorAll(".gradient-test-split .words"),
      {
        yPercent: 100,
        // opacity: 0,
        stagger: 0.02,
        duration: 0.8,
        ease: "power2.out",
      },
      {
        yPercent: 0,
        // opacity: 1,
        stagger: 0.02,
        duration: 0.8,
        ease: "power2.out",
      }
    );

/*
  // image animation
 let imageContainers = document.querySelectorAll( 
    ".bg-light.image-multicolumn-2 .multicolumn-card , .main-container .image-wrapper , .sticky-vertcial-section .custom-image-wrapper"
  );

  // let rule = CSSRulePlugin.getRule(".reveal:after");

    let header = document.querySelector('header.header');
let header_height = header ? header.offsetHeight : 0;
    console.log(header_height);
  imageContainers.forEach((el) => {
    let image = el.querySelector(".image-overlay-animate");
    let header_height = document.querySelector('header.header').offsetHeight;

let startValue = window.innerWidth < 749 ? "top center" : `top ${header_height}px`;

let t2 = gsap.timeline({
  scrollTrigger: {
    trigger: el,
    start: startValue,
    end: "center center",
    toggleActions: "play none none none",
    markers: false,
  },
});

    t2.fromTo(
       image, 
      {
        yPercent: 0,
        Height: 0,
      },
      {
        yPercent: -100,

        ease: "expo.out",
        duration: 0.8,
        Height: "auto",
        // stagger: 0.1,
      }
    );
  });
*/

//  image animation slide up/ down
// const reveal_duration = 1.2;
// const easing_type = "expo.inOut";

// // Select your wrapper containers (update selectors as needed)
// const wrappers = gsap.utils.toArray(
//   ".bg-light.image-multicolumn-2 .multicolumn-card, .main-container .image-wrapper, .sticky-vertcial-section .custom-image-wrapper , .bg-dark.sample-reportt .multicolumn-card "
// );

// wrappers.forEach(function (wrapper) {
//   const img = wrapper.querySelector(".image-overlay-animate");
//   if (!img) return;

//   // Initial hidden state
//   gsap.set(wrapper, {
//     clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
//     overflow: "hidden"
//   });

//   gsap.set(img, {
//     autoAlpha: 0,
//     scale: 1.2
//   });

//   ScrollTrigger.create({
//     trigger: wrapper,
//     start: "top 80%",
//     once: true,
//     onEnter: function () {
//       revealItem(wrapper, img);
//     }
//   });
// });

// function revealItem(wrapper, img) {
//  const images = wrapper.querySelectorAll("img , .custom-image-wrapper-inner ");
//   let tl = gsap.timeline();

//   tl.to(wrapper, {
//     duration: reveal_duration,
//     clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
//     ease: easing_type
//   }, 0); 
//   tl.to(images, {
//     scale: 1.2,
//     duration: reveal_duration,
//     ease: "power2.out"
//   }, 0 ); 

//  // tl.to(images, {
//  //    scale: 1,
//  //    duration: 0.8, 
//  //    ease: "expo.out", 
//  //    delay: 0.2
//  //  });
  
//   // gsap.to(img, {
//     // duration: reveal_duration * 1.2,
//     // autoAlpha: 1,
//     // scale: 1,
//     // ease: easing_type,
//     // onComplete: () => {
//       // Lock final styles to prevent fade-out bugs
//       // gsap.set(img, {
//       //   clearProps: "all"
//       // });
//     // }
//   // });
// }



//  image animation fade in 
// const wrappers = gsap.utils.toArray(
//   ".bg-light.image-multicolumn-2 .multicolumn-card, .main-container .image-wrapper, .sticky-vertcial-section .custom-image-wrapper , .bg-dark.sample-reportt .multicolumn-card "
// );

gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".bg-light.image-multicolumn-2 .multicolumn-card, .main-container .image-wrapper, .sticky-vertcial-section .custom-image-wrapper , .bg-dark.sample-reportt .multicolumn-card").forEach((el) => {
  // Set initial state
  gsap.set(el, { opacity: 0, y: 10 });

  // Check if already in viewport AND above 80% threshold
  const rect = el.getBoundingClientRect();
  const top80 = window.innerHeight * 0.8;

  if (rect.top < window.innerHeight && rect.top > top80) {
    // In viewport but before ScrollTrigger threshold → animate manually
    gsap.to(el, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power1.out",
      delay: 1, // small delay added here
    });
  } else {
    // Otherwise, let ScrollTrigger handle it
    gsap.to(el, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power1.out",
      delay: 0.25, // small delay added here
      scrollTrigger: {
        trigger: el,
        start: "top center",
        toggleActions: "play none none none",
        once: true,
        // markers: true, // uncomment for debugging
      },
    });
  }
});

ScrollTrigger.refresh();


});




